var nurseslounge_myDashboard_manageMyLounges = {
    init:function($params){
        nurseslounge_myDashboard_manageMyLounges.first_load($params);
        //nurseslounge_myDashboard_manageMyLounges.banners_location(function($config){
        //    nurseslounge_myDashboard_myProfile.banners_engine($config);
        //});
        nurseslounge_myDashboard_manageMyLounges.report_container(function($container){
            nurseslounge_myDashboard_manageMyLounges.report($container, $params);
        });
    },
    first_load:function($params){
        var $manageMyLoungeLeft = $("#nurseslounge-home-manage-my-lounges .nurseslounge-home-manage-my-lounges-left");
        var $listWrapper = $manageMyLoungeLeft.find('.manage-my-lounge-list-wrapper');
        var $manageMyLoungeForm = $manageMyLoungeLeft.find('form');
        var $loungeTypes = $manageMyLoungeForm.find('select[name="loungeTypes"]');
        var $autocompleteWrapper = $manageMyLoungeForm.find('.manage-my-lounge-list-autocomplete-wrapper');
        var $name = $manageMyLoungeForm.find('input[name="name"]');
        try{
            $loungeTypes.chosen('destroy');
        }catch (e) {}
        $loungeTypes.chosen();
        $loungeTypes.unbind();
        $loungeTypes.change(function(){
            var $that = $(this);
            var $val = $that.val();
            if($val.length > 0){
                $autocompleteWrapper.fadeIn();
                $listWrapper.fadeIn();
            }else{
                $autocompleteWrapper.hide();
                $listWrapper.hide();
            }
            nurseslounge_myDashboard_manageMyLounges.search($params);
        });
        nurseslounge_myDashboard_manageMyLounges.autocomplete(
            $name,
            $params,
            "/lounges/home/autocomplete",
            function($keyword){
                nurseslounge_myDashboard_manageMyLounges.search($params);
            }
        );
        nurseslounge_myDashboard_manageMyLounges.search($params);
    },
    autocomplete:function($target, $data, $url, cback){
        var $manageMyLoungeLeft = $("#nurseslounge-home-manage-my-lounges .nurseslounge-home-manage-my-lounges-left");
        var $manageMyLoungeForm = $manageMyLoungeLeft.find('form');
        var $loungeTypes = $manageMyLoungeForm.find('select[name="loungeTypes"]');
        try {
            $($target).autocomplete("destroy");
        }catch (e) {
        }
        var $value = '';
        $($target).autocomplete({
            minLength	:2,
            search		: function(){
                $(this).addClass("ui-autocomplete-loading");
            },
            open 		: function(){
                $(this).removeClass("ui-autocomplete-loading");
            },
            source: function(request, response) {
                $.ajax({
                    method: 'POST',
                    url:$url,
                    data:$.extend({
                        keyword:$($target).val(),
                        typeName:$loungeTypes.val()
                    }, $data),
                    dataType: "json",
                    success: function($data){
                        libs.expire($data);
                        $value = '';
                        response($data);
                    }
                });
            },
            create:function(){
                $(this).prev().remove();
                $(this).trigger("keypress.autocomplete");
            },
            select: function (event, ui) {
                $value = ui.item.value;
                $(this).val($value);
                cback($value);
                return false;
            }
        }).keypress(function ($e) {
            if ($e.which == 13) {
                cback($(this).val());
                $(this).autocomplete("close");
            }
        });
    },
    search:function($params){
        var $manageMyLoungeLeft = $("#nurseslounge-home-manage-my-lounges .nurseslounge-home-manage-my-lounges-left");
        var $loungeList = $manageMyLoungeLeft.find('.manage-my-lounge-list:first');
        var $manageMyLoungeForm = $manageMyLoungeLeft.find('form');
        var $loungeTypes = $manageMyLoungeForm.find('select[name="loungeTypes"]');
        var $name = $manageMyLoungeForm.find('input[name="name"]');
        var $loungeListPreview = nurseslounge_myDashboard_manageMyLounges.preview();
        var $resultInfo = $manageMyLoungeLeft.find(".result-info-count:first");
        var $resultPreview = '&nbsp;';
        var $paginationNav = $manageMyLoungeLeft.find('.pagination-nav');
        var $paginationNavPreview = '&nbsp;';
        var $listWrapper = $manageMyLoungeLeft.find('.manage-my-lounge-list-wrapper');
        var $autocompleteWrapper = $manageMyLoungeForm.find('.manage-my-lounge-list-autocomplete-wrapper');
        $params = $.extend({},$params,{
            name:$name.val(),
            typeName:$loungeTypes.val(),
        });
        $resultInfo.addClass('nurseslounge-home-manage-my-lounges-preload').html($resultPreview);
        $paginationNav.addClass('nurseslounge-home-manage-my-lounges-preload').html($paginationNavPreview);
        if($params.typeName.length > 0) {
            $loungeList.html($loungeListPreview).promise().done(function () {
                $autocompleteWrapper.fadeIn();
                $listWrapper.fadeIn();
                nurseslounge_myDashboard_manageMyLounges.pagination($params);
            });
        }
    },
    preview:function(){
        var $chtml = '';
        for(var $i=1; $i<=10; $i++){
            $chtml+= '' +
                '<li class="shadow p-3 mb-3 bg-white rounded preview">' +
                '    <div class="row">' +
                '        <div class="col align-self-center">' +
                '            <div class="d-flex">' +
                '                <div class="profile-img mr-4 nurseslounge-home-manage-my-lounges-preload">' +
                '                   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                </div>' +
                '                <div class="list-info align-self-center w-100">' +
                '                    <h4 class="lounge-name nurseslounge-home-manage-my-lounges-preload">' +
                '                       &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                       &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                       &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                       &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    </h4>' +
                '                    <p class="lounge-followers nurseslounge-home-manage-my-lounges-preload">' +
                '                       &nbsp;' +
                '                    </p>' +
                '                </div>' +
                '            </div>' +
                '        </div>' +
                '        <div class="col-md-auto text-center text-sm-right align-self-center">' +
                '            <div class="clg-rating">' +
                '                <div class="rating-stars mb-1">' +
                '                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="#E2E2E9"><polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566 "></polygon></svg>' +
                '                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="#E2E2E9"><polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566 "></polygon></svg>' +
                '                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="#E2E2E9"><polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566 "></polygon></svg>' +
                '                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="#E2E2E9"><polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566 "></polygon></svg>' +
                '                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="#E2E2E9"><polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566 "></polygon></svg>' +
                '                </div>' +
                '                <div class="rating-count text-center text-sm-right nurseslounge-home-manage-my-lounges-preload">' +
                '                   &nbsp;' +
                '                </div>' +
                '            </div>' +
                '            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '        </div>' +
                '    </div>' +
                '</li>';
        }
        return $chtml;
    },
    pagination:function($params){
        var $reload;
        var $loaded = false;
        var $afterFirstPagination = false;
        var $manageMyLoungeLeft = $("#nurseslounge-home-manage-my-lounges .nurseslounge-home-manage-my-lounges-left");
        var $manageMyLoungeForm = $manageMyLoungeLeft.find('form');
        var $loungeTypes = $manageMyLoungeForm.find('select[name="loungeTypes"]');
        var $loungeList = $manageMyLoungeLeft.find(".manage-my-lounge-list:first");
        var $paginationNav = $manageMyLoungeLeft.find('.pagination-nav');
        var $previewHeight = $manageMyLoungeLeft.find('.manage-my-lounge-list .preview:first').innerHeight();
        var $loungeHeight = $loungeList.innerHeight();
        var $pageSize = Math.round(($loungeHeight/$previewHeight));
        var $resultInfo = $manageMyLoungeLeft.find(".result-info-count:first");
        var $saveParams = $params;
        var $paginationObj;
        try {
            $paginationObj = libs.memoryGet('manage_my_lounge_pagination');
            if ($paginationObj) {
                $paginationObj.pagination('destroy');
            }
        } catch ($e) {
        }
        $paginationObj = $paginationNav.pagination({
            pageSize: $pageSize,
            showPageNumbers: true,
            showPrevious: true,
            showNext: true,
            showNavigator: true,
            showFirstOnEllipsisShow: true,
            showLastOnEllipsisShow: true,
            dataSource: window.location.protocol + '//' + window.location.hostname + "/myDashboard/manageMyLounges/get",
            locator: 'data.lounges',
            ajax: {
                method: "POST",
                cache: false,
                dataType: "json",
                data: $params,
                beforeSend: function () {
                    $loungeList.html(nurseslounge_myDashboard_manageMyLounges.preview());
                },
                complete: function ($data) {
                    libs.expire($data.responseJSON);
                }
            },
            totalNumberLocator: function ($data) {
                return $data.data.total;
            },
            callback: function ($data, $pagination) {
                $loaded = true;
                var $title = [];
                var $loungeTypesVal = $loungeTypes.val();
                if ($loungeTypesVal.length > 0 && $.inArray('employers', $loungeTypesVal) != -1) {
                    $title.push('Employers');
                }
                if ($loungeTypesVal.length > 0 && $.inArray('schools', $loungeTypesVal) != -1) {
                    $title.push('Schools');
                }
                if ($loungeTypesVal.length > 0 && $.inArray('nurseAssociations', $loungeTypesVal) != -1) {
                    $title.push('Nurse Associations');
                }
                if ($loungeTypesVal.length > 0 && $.inArray('states', $loungeTypesVal) != -1) {
                    $title.push('States');
                }
                if ($loungeTypesVal.length > 0 && $.inArray('specialties', $loungeTypesVal) != -1) {
                    $title.push('Specialties');
                }
                $title = $title.join(', ');
                if ($loungeList.length > 0 && $loungeList.offset().top > 0 && $afterFirstPagination) {
                    $('html, body').animate({scrollTop: $loungeList.offset().top - 100});
                } else {
                    $afterFirstPagination = true;
                }
                var $pageNumber = $pagination.pageNumber;
                var $pageSize = $pagination.pageSize;
                var $totalNumber = $pagination.totalNumber;
                var $first = $totalNumber > 0 ? (($pageNumber - 1) * $pageSize) + 1 : 0;
                var $last = $totalNumber > 0 ? ($first + $data.length - 1) : 0;
                $paginationNav.removeClass('nurseslounge-home-manage-my-lounges-preload');
                $resultInfo.removeClass('nurseslounge-home-manage-my-lounges-preload').html('<strong>Showing ' + $first + ' - ' + $last + ' of ' + $totalNumber + '</strong> results for <span class="link-color">' + $title + '</span>');
                var $chtml = nurseslounge_myDashboard_manageMyLounges.item($data);
                libs.checkImageLoad($($chtml).find('img'), function () {
                    $loungeList.html('').html($chtml).promise().done(function () {
                        nurseslounge_myDashboard_manageMyLounges.events($saveParams);
                    });
                });
            }
        });
        libs.memorySave('manage_my_lounge_pagination', $paginationObj);
        $reload = setTimeout(function(){
            if(!$loaded){
                nurseslounge_myDashboard_manageMyLounges.lounge_pagination($params);
            }else{
                clearTimeout($reload);
            }
        }, 10000);

    },
    item:function($lounges){
        var $chtml = '';
        var $userId = libs.memoryGet('user_id');
        $.each($lounges, function($i, $v){
            var $img = $v.logo_root_lounge;
            var $publicLink = $v.public_link;
            var $ownerClass = $v.isOwner ? 'open-lounge':'claim-lounge';
            $chtml+='' +
                '<li class="shadow p-3 mb-3 bg-white rounded item" data-key="'+$v.key+'" data-public_link="'+$publicLink+'">' +
                '    <div class="row '+$ownerClass+'">' +
                '        <div class="col align-self-center">' +
                '            <div class="d-flex">' +
                '                <div class="profile-img mr-4">' +
                '                     <img src="'+$img+'?resize=80" alt="lounge">' +
                '                </div>' +
                '                <div class="list-info align-self-center w-100">' +
                '                    <h4 class="lounge-name">' +
                '                         <a href="javascript:void(0)">'+$v.name+'</a>' +
                '                    </h4>';
            if($v.lounge_type_id != 1 && $v.lounge_type_id != 2){
                $chtml+='' +
                    '<p class="lounge-followers">' +
                    $v.followers_count+ ' Followers' +
                    '</p>';
            }
            $chtml+='' +
                '                </div>' +
                '            </div>' +
                '        </div>' +
                '        <div class="col-md-auto text-center text-sm-right align-self-center">';
            if($v.lounge_type_id == 1 || $v.lounge_type_id == 2){
                $chtml+='' +
                    '            <div class="clg-rating">' +
                    '                <div class="rating-stars mb-1">' +
                    nurseslounge_myDashboard_manageMyLounges.add_stars($v.rating) +
                    '                </div>' +
                    '                <div class="rating-count text-center text-sm-right">' +
                    $v.rating + ' / 5 ' +
                    '                </div>' +
                    '                <div class="select-count text-center text-sm-right">' +
                    '                   <button type="button" class="btn btn-save btnAnimate">Show Activity Report</button>' +
                    '               </div>' +
                    '            </div>';
            }else{
                $chtml+='' +
                    '            <div class="clg-rating select-count">' +
                    '                <div class="rating-stars mb-1">' +
                    '                   &nbsp;&nbsp;&nbsp;&nbsp;' +
                    '                </div>' +
                    '                <div class="rating-count text-center text-sm-right">' +
                    '                   &nbsp;&nbsp;&nbsp;&nbsp;' +
                    '                </div>' +
                    '            </div>';
            }
            if($userId != 'guest' && $v.lounge_type_id != 1 && $v.lounge_type_id != 2){
                if($v.my_follow) {
                    $chtml +='<button type="button" class="btn btn-light follow-action follow">Followed</button>';
                }else{
                    $chtml+='<button type="button" class="btn btn-save btnAnimate follow-action">Follow</button>';
                }
            }
            $chtml+='' +
                '        </div>' +
                '    </div>' +
                '</li>';
        });
        return $chtml;
    },
    add_stars:function($rating){
        var $chtml = '';
        for(var $i=1; $i<=5; $i++) {
            var $star = $rating - $i;
            var $offsetOn;
            var $offsetOff;
            var $unique = libs.getUniqueId();
            if($star >= 0){
                $offsetOn = 100;
                $offsetOff = 0;
            }else if($star < 0 && $star > -1){
                $star = ($star * -1);
                $offsetOff = ($star * 100);
                $offsetOn = (100 - $offsetOff);
            }else{
                $offsetOn = 0;
                $offsetOff = 100;
            }
            $chtml += '' +
                '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="url(#percent'+$unique+')">' +
                '   <defs>' +
                '       <linearGradient id="percent'+$unique+'">';
            if($offsetOn > 0) {
                $chtml += '' +
                    '<stop offset="' + $offsetOn + '%" stop-color="#FDA630" stop-opacity="1"></stop>';
            }
            if($offsetOff > 0){
                $chtml += '' +
                    '<stop offset="'+$offsetOff+'%" stop-color="#E2E2E9" stop-opacity="1"></stop>';
            }
            $chtml += '' +
                '       </linearGradient>' +
                '   </defs>' +
                '   <polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566"></polygon>' +
                '</svg>';
        }
        return $chtml;
    },
    events:function($params){
        var $manageMyLoungeLeft = $("#nurseslounge-home-manage-my-lounges .nurseslounge-home-manage-my-lounges-left");
        var $loungeList = $manageMyLoungeLeft.find('.manage-my-lounge-list:first');
        var $userId = libs.memoryGet('user_id');
        $loungeList.find(".follow-action").unbind().click(function($e){
            $e.stopPropagation();
            var $that = $(this);
            var $follow = !$that.hasClass('follow');
            var $item = $that.parents('.item:first');
            var $key = $item.data('key');
            var $params = {user_id:$userId, key:$key, follow:$follow};
            nurseslounge_lounges_home.lounges_home_list_follower_request($params, function($data){
                if($data.status == 'success'){
                    var $follow = $data.data.follow;
                    var $members = $data.data.members;
                    $item.find('.lounge-followers:first').html($members+ ' Followers');
                    if($follow){
                        $item.find('.follow-action').removeClass('btn-save').removeClass('btnAnimate').addClass('btn-light').addClass('follow').html('Followed');
                    }else{
                        $item.find('.follow-action').removeClass('btn-light').removeClass('follow').addClass('btn-save').addClass('btnAnimate').html('Follow');
                    }
                }
            });
        });
        $loungeList.find(".claim-lounge").unbind().click(function(){
            var $key = $(this).parents('.item:first').data('key');
            var $modal = $("#nurseslounge-claim-lounges-modal");
            var $modalTitle = $modal.find(".modal-title");
            var $modalBody = $modal.find(".modal-body");
            $params = $.extend({}, $params, {key:$key});
            nurseslounge_lounge_overview.claim_lounge_form_request($params, function($chtml){
                $modalTitle.html('Contact us to own this Lounge');
                $modalBody.html($chtml).promise().done(function(){
                    nurseslounge_lounge_overview.claim_lounge_validate(function($form){
                        $params = $.extend({}, $params, libs.getObjForm($form));
                        nurseslounge_lounge_overview.claim_lounge_request($params, function(){
                            $modal.modal('hide');
                        });
                    });
                    $modal.find("form input[name='phone']").mask('+(00) 000-000-0000');
                    $modal.modal('show');
                });
            });
        });
        $loungeList.find(".open-lounge").unbind().click(function(){
            var $key = $(this).parents('.item:first').data('key');
            var $publicLink = $(this).parents('.item:first').data('public_link');
            if($userId == 'guest'){
                window.open($publicLink,'_self');
            }else{
                router.navigate('/lounge/'+$key);
            }
        });
        $loungeList.find(".select-count").unbind().click(function($e){
            $e.stopPropagation();
            var $that = $(this);
            var $item = $that.parents('.item:first');
            var $key = $item.data('key');
            var $params = {user_id:$userId, key:$key};
            nurseslounge_myDashboard_manageMyLounges.open_dashboard($params);
            nurseslounge_myDashboard_manageMyLounges.report_container(function($container){
                nurseslounge_myDashboard_manageMyLounges.report($container, $params);
            });
        });
        var $selectCount = $loungeList.find(".select-count").length;
        if($selectCount <= 1){
            $loungeList.find(".select-count").hide();
        }else{
            $loungeList.find(".select-count").show();
        }
        if($selectCount > 0){
            $loungeList.find(".select-count:first").click();
        }
    },
    //Banners
    banners_location:function(cback){
        cback({
            'banners':$("#nurseslounge-home-manage-my-lounges .nurseslounge-home-manage-my-lounges-right .banners")
        });
    },
    //Report
    report_container:function(cback){
        var $container = $("#nurseslounge-home-manage-my-lounges .nurseslounge-home-manage-my-lounges-right .report");
        cback($container);
    },
    report:function($container, $params){
        nurseslounge_myDashboard_manageMyLounges.report_request($params, function($chtml){
            $container.html($chtml).promise().done(function(){
                libs.refreshTooltips();
            });
        });
    },
    report_request:function($params, cback){
        $.ajax({
            type: 'POST',
            url: '/myDashboard/manageMyLounges/report/get',
            data:$params,
            method: "POST",
            cache:false,
            dataType: "html",
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    //Dashboard
    open_dashboard:function($params){
        var $statisticWrapper = $("#nurseslounge-home-manage-my-lounges .nurseslounge-home-manage-my-lounges-left .manage-my-lounge-statistics-wrapper");
        nurseslounge_myDashboard_manageMyLounges.open_dashboard_request($params, function($chtml){
            $statisticWrapper.html($chtml).promise().done(function(){
                nurseslounge_myDashboard_manageMyLounges.open_dashboard_events();
            });
        });
    },
    open_dashboard_request:function($params, cback){
        $.ajax({
            type: 'POST',
            url: '/myDashboard/manageMyLounges/dashboard/get',
            data:$params,
            method: "POST",
            cache:false,
            dataType: "html",
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    open_dashboard_events:function(){
        libs.refreshTooltips();
        var $statisticWrapper = $("#nurseslounge-home-manage-my-lounges .nurseslounge-home-manage-my-lounges-left .manage-my-lounge-statistics-wrapper");
        var $days = $statisticWrapper.find('select[name="days"]');
        var $userId = libs.memoryGet('user_id');
        $days.unbind().change(function(){
            var $that = $(this);
            var $key = $that.data('key');
            var $days = $that.val();
            var $params = {user_id:$userId, key:$key, days:$days};
            nurseslounge_myDashboard_manageMyLounges.open_dashboard($params);
        });
    },
};
